import { t } from "./locale";
import React from "react";
import { createRoot } from "react-dom/client";
import { lazy, Suspense } from "react";
import PortalApp from "./portal/PortalApp";
import { config } from "./config";
import { ViewerProvider } from "./members/Viewer";
import UpdateNotice from "./UpdateNotice";
import "@fontsource/dm-sans/latin-400.css";
import "@fontsource/dm-sans/latin-500.css";
import "@fontsource/dm-sans/latin-700.css";
import "@fontsource/manrope/latin-400.css";
import "@fontsource/manrope/latin-700.css";
import "@fontsource/manrope/latin-800.css";
import "./portal/portal.css";
import "./portal/apple-install.css";
import "./locale.css";
const DemoPlayer = lazy(() => import("./portal/DemoPlayer"));
const AccountPage = lazy(() => import("./members/AccountPage"));
const StoriesApp = lazy(() => import("./App"));
const isDemoPlayer = location.pathname.replace(/\/$/, "") === "/preview/player";
const isAccount = location.pathname.replace(/\/$/, "") === "/account";
const isStories =
  config.demo &&
  (location.pathname.replace(/\/$/, "") === "/stories" ||
    /^#\/(watch|series|profile|library|discover)(\/|$)/.test(location.hash));
createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {window.top === window.self && <UpdateNotice />}
    <ViewerProvider>
      {isAccount ? (
        <Suspense
          fallback={
            <div className="player-loading">{t("Loading your account…")}</div>
          }
        >
          <AccountPage />
        </Suspense>
      ) : isStories ? (
        <Suspense
          fallback={
            <div className="player-loading">{t("Loading stories…")}</div>
          }
        >
          <StoriesApp />
        </Suspense>
      ) : isDemoPlayer && config.demo ? (
        <Suspense
          fallback={<div className="player-loading">{t("Loading video…")}</div>}
        >
          <DemoPlayer />
        </Suspense>
      ) : (
        <PortalApp />
      )}
    </ViewerProvider>
  </React.StrictMode>,
);
